export default () => {
    const split = document.querySelectorAll('.split');
    if (!split.length)
        return;
    import(/* webpackChunkName: "splitText" */ "../classes/splitTextClass")
        .then(({ default: SpliTextClass }) => {
        split.forEach((node) => new SpliTextClass(node));
    })
        .catch((err) => console.error('Error loading SplitText class:', err));
};
